import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialCommitteeRegularInviteeState: Dtos.CommitteeRegularInvitee & IRegistrationFormState = {
    id: null,
    committeeId: null,
    committee: null,
    personnelId: null,
    personnel: null,
    comment: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ICommitteeRegularInviteeReduxFormState {
    id: IFieldState<number>,
    committeeId: IFieldState<number>,
    personnelId: IFieldState<number>,
    comment: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
